import React, { useState } from "react";
import FaqData from "./FaqData";
import HeaderWrapper from "../../../components/common/HeaderWrapper";
import { SearchIcon } from "../../../components/common/IconComponents";
import CustomButton from "../../../components/common/CustomButton";
import { useNavigate } from "react-router-dom";

const Faq = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const handleSearch = (event) => {
    const inputText = event.target.value;
    const sanitizedText = inputText.replace(/\s/g, ""); // Remove spaces from the input text
    setSearchQuery(sanitizedText);
  };

  return (
    <main className="p-8">
      <HeaderWrapper>
        <div className="flex justify-between items-center  w-full">
          <div className="flex items-center">
            <h1 className="font-medium text-xl xl:mr-6 sm:-mr-2">FAQS</h1>
            <div className="relative ml-6 sm:mr-3">
              <input
                type="text"
                value={searchQuery}
                id="seach"
                role="search"
                placeholder="Search"
                className="xl:w-[520px] md:w-[400px] sm:w-45 xl:py-1 xl:pl-8 xl:pr-4 sm:pr-2 sm:pl-4 border-0 rounded-3xl bg-gray-50"
                onChange={handleSearch}
              />
              <span className="absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none">
                <SearchIcon className="text-gray-500" />
              </span>
            </div>
          </div>

          <span className="xl:mr-6 sm:mr-2">
            <CustomButton
              className="xl:px-5 md:px-2 lg:px-3 xl:py-2 sm:p-0.5"
              onClick={() => navigate("/CreateModelStep1")}
            >
              Create Model
            </CustomButton>
          </span>
        </div>
      </HeaderWrapper>

      <section>
        <FaqData searchQuery={searchQuery} />
      </section>
    </main>
  );
};

export default Faq;
